import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import $ from 'jquery'

export default {
    name: "navbar",
    components: {},
    props: [],
    data() {
        return {
            user_role: 0,
            compte_id: 0,
            user_id: 0,

            all_apps: false,
            menu_state: 0,

            vm_state: open_menu_state,
            counter: 0,
            remaining_time: {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            },
            is_close: 0
        };
    },  
    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole(){
            return this.$store.getters['activeRole'];
        },

        auth_user(){
            return this.$store.getters['auth_user'];
        },

        countdown_info() {
            return this.$store.getters['countdown_info'];
        }
    },

    mounted() {
        this.$store.dispatch('getCountDown').then(() => {
            this.calcTimeRemaining()
        })
        
        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id
            this.user_role = this.userCredentials.user.roles[0].nom;

            this.$store.dispatch("getAuthUser", { user_id: this.user_id })
        } 

        this.getCurrencyInfo()
        

        let t = this;
        $(document).bind("click", function(e) {
            let $clicked = $(e.target);
            
            if (!$clicked.parents().hasClass("menu-container")) {
                if(t.vm_state != 0) {
                    t.openMenu(t.vm_state, 'user-menu')
                }
            }

            if (!$clicked.parents().hasClass("menu-container")) {
                if (t.menu_state != 0) {
                    $('.all-apps').removeClass('animate-zoomIn');
                    $('.all-apps').addClass('animate-zoomOut');
                    $('.all-apps').fadeOut();
                    t.menu_state = 0;
                }
                
            }
        });

        // Listen for closeSidebar event from sidebar component
        this.$root.$on('closeSidebar', () => {
            if (this.is_close == 1) {
                this.toggleSidebar();
            }
        });
    },

    beforeDestroy() {
        // Clean up event listener
        this.$root.$off('closeSidebar');
    },

    methods: {
        calcTimeRemaining() {
            this.counter = this.countdown_info.duree_restant.total_secondes
            
            setInterval(() => {
                let total_seconds = this.counter;

                // Convert the remaining time back to days, hours, minutes, and seconds
                let remaining_days = Math.floor(total_seconds / (24 * 60 * 60));
                total_seconds %= (24 * 60 * 60);

                let remaining_hours = Math.floor(total_seconds / (60 * 60));
                total_seconds %= (60 * 60);

                let remaining_minutes = Math.floor(total_seconds / 60);
                let remaining_seconds = total_seconds % 60;

                this.remaining_time = {
                    days: remaining_days,
                    hours: remaining_hours,
                    minutes: remaining_minutes,
                    seconds: remaining_seconds
                }
                
                this.counter -= 1
            }, 1000)
        },

        displayapps(v) {
            if (v == 0) {
                v = 1;
            } else {
                v = 0;
            }
    
            if (this.menu_state == 0) {
                $('.all-apps').fadeIn();
                $('.all-apps').removeClass('animate-zoomOut');
                $('.all-apps').addClass('animate-zoomIn');
            } else {
                $('.all-apps').removeClass('animate-zoomIn');
                $('.all-apps').addClass('animate-zoomOut');
                $('.all-apps').fadeOut();
            }

            this.menu_state = v;
        },

        /**
         * Open Menu Dropdown
         */
        async openMenu(state, selector) 
        {
            this.vm_state = openMenu.dropMenu(state, selector)
        },

        /**
         * Close Menu Dropdown
         */
        async closeMenu(selector) 
        {
            this.vm_state = closeMenu.wrapMenu(selector)
        }, 

        resetVuexState() {
            const freshState = {};
            const modules = this.$store._modules.root._children || {};

            Object.keys(modules).forEach((moduleName) => {
                const module = modules[moduleName];
                const moduleState = typeof module.state === 'function' ? module.state() : module.state;

                freshState[moduleName] = moduleState && typeof moduleState === 'object'
                    ? { ...moduleState }
                    : moduleState;
            });

            this.$store.replaceState(freshState);
        },

        async logout()
        {
            this.resetVuexState();
            localStorage.removeItem('vuex');
            localStorage.clear();
            this.$router.push({"path": "/login"})
        },

        switchRole: function(userId,roleId){
            if (roleId == 2 || roleId == 3 || roleId == 7 || roleId == 16 || roleId == 17) {
                window.location = this.base_url_clinique
            } else if (roleId == 9 || roleId == 6) {
                window.location = this.base_url_stock
            }else if (roleId == 11) {           // ROLE_RH
                window.location = this.base_url_rh
            } else {
                this.$store.dispatch('switchRole',{userId:userId,roleId:roleId}).then(() => {
                    if (roleId == 1 || roleId == 5) {
                        this.$router.push({"path": "/tableau-de-bord"})
                    } else if (roleId == 14) {
                        this.$router.push({"path": "/tresorerie"})
                    } else {
                        this.$router.push({"path": "/"})
                    }
                })
            }
        },

        getCurrencyInfo() {
            this.$store.dispatch('getConfigInfoClinique', 'currency')
        },

        toggleSidebar() {
            this.is_close = (this.is_close == 0)?1:0

            if (this.is_close == 1) {
                $('.sidebar').addClass('shw-sdbar');
            } else {
                $('.sidebar').removeClass('shw-sdbar');
            }
        }
    }
};